/* tslint:disable */
import {
  PatientNotificationChain
} from '../index';

declare var Object: any;
export interface PatientNotificationInterface {
  "text": string;
  "personalised"?: boolean;
  "send"?: Date;
  "id"?: any;
  "chainId"?: any;
  "created"?: Date;
  chain?: PatientNotificationChain;
}

export class PatientNotification implements PatientNotificationInterface {
  "text": string;
  "personalised": boolean;
  "send": Date;
  "id": any;
  "chainId": any;
  "created": Date;
  chain: PatientNotificationChain;
  constructor(data?: PatientNotificationInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PatientNotification`.
   */
  public static getModelName() {
    return "PatientNotification";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PatientNotification for dynamic purposes.
  **/
  public static factory(data: PatientNotificationInterface): PatientNotification{
    return new PatientNotification(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PatientNotification',
      plural: 'PatientNotifications',
      path: 'PatientNotifications',
      idName: 'id',
      properties: {
        "text": {
          name: 'text',
          type: 'string'
        },
        "personalised": {
          name: 'personalised',
          type: 'boolean',
          default: false
        },
        "send": {
          name: 'send',
          type: 'Date',
          default: new Date(0)
        },
        "id": {
          name: 'id',
          type: 'any'
        },
        "chainId": {
          name: 'chainId',
          type: 'any'
        },
        "created": {
          name: 'created',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        chain: {
          name: 'chain',
          type: 'PatientNotificationChain',
          model: 'PatientNotificationChain',
          relationType: 'belongsTo',
                  keyFrom: 'chainId',
          keyTo: 'id'
        },
      }
    }
  }
}
